import { IParsedCurrentWhitelabel } from '@/Interfaces/Whitelabels/Whitelabel.interface';
import CurrentWhitelabelService from '@/Services/Whitelabels/CurrentWhitelabel.service';
import type { RequestId } from '@/types/Slice.type';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getCurrentWhitelabelData } from '../api/whitelabels.api';
import { pendingCaseHandler, rejectedCaseHandler } from '../asyncThunkHandlers';

interface IState {
  whitelabel: IParsedCurrentWhitelabel;
  whitelabelRequestId: RequestId;
}

enum Action {
  GetCurrentWhitelabel = 'currentWhitelabel/getCurrentWhitelabel',
  RefreshCurrentWhitelabel = 'currentWhitelabel/refreshCurrentWhitelabel',
}

const initialState: IState = {
  whitelabel: CurrentWhitelabelService.defaultCurrentWhitelabel,
  whitelabelRequestId: null,
};

export const getCurrentWhitelabel = createAsyncThunk(Action.GetCurrentWhitelabel, async _payload => {
  return await getCurrentWhitelabelData();
});

export const refreshCurrentWhitelabelInBackground = createAsyncThunk(
  Action.RefreshCurrentWhitelabel,
  async _payload => {
    return await getCurrentWhitelabelData();
  },
);

export const whitelabelSlice = createSlice({
  name: 'currentWhitelabel',
  initialState,
  reducers: {
    updateCurrentWhitelabel: (state, action) => {
      if (state.whitelabel.id === action.payload.id) {
        const theme = CurrentWhitelabelService.formatCurrentWhitelabelResponse(action.payload);
        state.whitelabel = theme;
        sessionStorage.setItem('whitelabel', JSON.stringify(theme));
      }
    },
    setWhitelabelFromCache: (state, action) => {
      state.whitelabel = action.payload;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(getCurrentWhitelabel.pending, pendingCaseHandler('whitelabel'))
      .addCase(getCurrentWhitelabel.rejected, rejectedCaseHandler('whitelabel'))
      .addCase(getCurrentWhitelabel.fulfilled, (state, action) => {
        if (state.whitelabelRequestId === action.meta.requestId) {
          state.whitelabel = action.payload;
          state.whitelabelRequestId = null;
          sessionStorage.setItem('whitelabel', JSON.stringify(action.payload));
        }
      })

      .addCase(refreshCurrentWhitelabelInBackground.fulfilled, (state, action) => {
        state.whitelabel = action.payload;
        sessionStorage.setItem('whitelabel', JSON.stringify(action.payload));
      });
  },
});

export const { updateCurrentWhitelabel, setWhitelabelFromCache } = whitelabelSlice.actions;

export default whitelabelSlice.reducer;
